// l'idee est de créer des points de sauvegarde a la main, et de reprendre à cet endroit

import SequencesManager from "react-sdk/haxelibs/SequencesManager"
import AppState from "./AppState"

import Ftues from "./Ftues";
import Chapters from "./Chapters";
import Minigames from "./Minigames/Minigames";
import SoundPlayer from "react-sdk/SoundPlayer";

class SaveGame {
  
  saveKey = "astek"
  #saveData = null

  #customData = null

  #reaxeApi = null

  updateState() {
    if (!this.#customData)
      return

    this.#customData.specific = {
      //sm_state: SequencesManager.stateToJson(),
      //ftue: Ftues.stateToJson(),
      chapters: Chapters.stateToJson(),
      ui : AppState.UI_visibilities,
      forceClick : AppState.forceClickUIElements,
      music : SoundPlayer.currentId,
      minigames : Minigames.stateToJson(),
    }

    console.warn("CD.specific : ", this.#customData.specific)
  }

  saveState(doneCB) {
    this.updateState()
    
    this.#reaxeApi.toHaxe("game", "saveCustomData").then(() => doneCB?.())
  }

  init(reaxeApi, saveData) {
    this.#reaxeApi = reaxeApi
    this.#saveData = saveData
    if (this.#saveData) {
      this.#customData = this.#saveData.customData
      if(this.#customData && this.#customData.specific) {
        let data = this.#customData.specific

        //SequencesManager.stateFromJson(data.sm_state)
        //Ftues.stateFromJson(data.ftue)
        Chapters.stateFromJson(data.chapters)
        AppState.UI_visibilities = data.ui
        if (data.forceClick)
          AppState.forceClickUIElements = data.forceClick
        Minigames.stateFromJson(data.minigames)

        if (data.music)
          SoundPlayer.playSound(data.music)

      }
    } else
      this.#customData = null
  }
}


export default new SaveGame()